/** Strings of `/reports` (analytics), `/activity`, `/mail` and the shared charts: `reportsEn` is the source, `reportsCs` must have the same keys. */
export const reportsEn = {
  rep: {
    title: "Analytics",
    subtitle: "Company health and the profitability of projects and people",
    from: "From",
    to: "To",
    operations: "Operations",
    pendingHours: "Pending Hours",
    issuesByStatus: "Issues by Status",
    issuesByPriority: "Issues by Priority",
    timeLast7: "Time Logged Last 7 Days",
    hoursPerDay: "Hours per day",
    topProjects: "Top Projects This Month",
    noTimeThisMonth: "No time entries this month.",
    activity14: "Activity — Last 14 Days",
    journalPerDay: "Journal entries per day",
    invoiced: "Invoiced",
    revenueBillable: "Revenue (billable time)",
    costRate: "Cost (time × cost rate)",
    margin: "Margin",
    companyHealth: "Company health",
    monthlyRevenue: "Monthly revenue — invoiced amounts",
    invoicedThisPeriod: "{{amount}} invoiced this period",
    trackedPerMonth: "Tracked hours per month",
    trackedTotal: "{{hours}} tracked in total",
    hoursMixTitle: "Billed vs unbilled vs non-billable hours",
    hoursMixSubtitle: "Where logged time lands",
    billable: "Billable",
    unbilled: "Unbilled",
    nonBillable: "Non-billable",
    invoiceMix: "Invoice status mix",
    paid: "{{amount}} paid",
    billableTrend: "Billable hours trend",
    monthlyBillable: "Monthly billable time",
    projectProfitability: "Project profitability",
    projectMarginRanking: "Project margin ranking",
    projectMarginSubtitle: "Revenue minus cost, top projects",
    revenueConcentration: "Revenue concentration",
    revenueConcentrationSubtitle: "Share of billed revenue by project",
    perProject: "Per-project breakdown",
    employeeProfitability: "Employee profitability & utilisation",
    employeeMarginRanking: "Employee margin ranking",
    employeeMarginSubtitle: "Revenue generated minus cost",
    utilisation: "Utilisation",
    utilisationSubtitle: "Billable share of logged hours",
    perEmployee: "Per-employee breakdown",
    noDataPeriod: "No data for this period.",
    colProject: "Project",
    colHours: "Hours",
    colRevenue: "Revenue",
    colCost: "Cost",
    colMargin: "Margin",
    colMarginPct: "Margin %",
    colEmployee: "Employee",
    colBillable: "Billable",
    colUtilisation: "Utilisation",
  },
  repActivity: {
    title: "Activity",
    subtitle: "Global activity stream across all projects",
    all: "All",
    types: {
      journal: "Changes",
      comment: "Comments",
      timeEntry: "Time Logged",
      syncJob: "Syncs",
    },
    groups: {
      today: "Today",
      yesterday: "Yesterday",
      thisWeek: "This Week",
      older: "Older",
    },
    filterUser: "Filter by user",
    allUsers: "All users",
    filterProject: "Filter by project",
    allProjects: "All projects",
    from: "From",
    to: "To",
    activityFrom: "Activity from",
    activityTo: "Activity to",
    system: "System",
    view: "View",
    none: "No activity found.",
  },
  repMail: {
    title: "Test mail",
    mailbox: "Test mailbox",
    landsHere: " · everything sent to *@{{domain}} lands here",
    recipient: "Recipient…",
    notConfigured: "The test mailbox isn't configured (TESTER_MAIL_ADDRESS / TESTER_MAIL_PASS).",
    readError: "Couldn't read the mailbox: {{error}}",
    noSubject: "(no subject)",
    to: "to {{addresses}}",
    noMessages: "No messages.",
    pageInfo: "{{total}} messages · page {{page}} / {{pages}}",
    pick: "Pick a message.",
    loading: "Loading…",
    rowFrom: "From",
    rowTo: "To",
    rowReplyTo: "Reply-To",
    date: "Date",
    attachment: "attachment {{n}}",
    text: "Text",
    message: "Message",
    empty: "(empty)",
  },
  miscCharts: {
    noData: "No data",
  },
};

export const reportsCs: typeof reportsEn = {
  rep: {
    title: "Analytika",
    subtitle: "Zdraví firmy a ziskovost projektů i lidí",
    from: "Od",
    to: "Do",
    operations: "Provoz",
    pendingHours: "Hodiny čekající na schválení",
    issuesByStatus: "Tikety podle stavu",
    issuesByPriority: "Tikety podle priority",
    timeLast7: "Vykázaný čas za posledních 7 dní",
    hoursPerDay: "Hodiny za den",
    topProjects: "Nejvytíženější projekty tohoto měsíce",
    noTimeThisMonth: "Tento měsíc zatím žádné časové záznamy.",
    activity14: "Aktivita — posledních 14 dní",
    journalPerDay: "Záznamy v deníku za den",
    invoiced: "Fakturováno",
    revenueBillable: "Tržby (fakturovatelný čas)",
    costRate: "Náklady (čas × nákladová sazba)",
    margin: "Marže",
    companyHealth: "Zdraví firmy",
    monthlyRevenue: "Měsíční tržby — fakturované částky",
    invoicedThisPeriod: "{{amount}} fakturováno v tomto období",
    trackedPerMonth: "Odpracované hodiny za měsíc",
    trackedTotal: "{{hours}} odpracováno celkem",
    hoursMixTitle: "Fakturované, nevyfakturované a nefakturovatelné hodiny",
    hoursMixSubtitle: "Kam míří vykázaný čas",
    billable: "Fakturovatelné",
    unbilled: "Nevyfakturované",
    nonBillable: "Nefakturovatelné",
    invoiceMix: "Struktura faktur podle stavu",
    paid: "{{amount}} zaplaceno",
    billableTrend: "Vývoj fakturovatelných hodin",
    monthlyBillable: "Fakturovatelný čas po měsících",
    projectProfitability: "Ziskovost projektů",
    projectMarginRanking: "Pořadí projektů podle marže",
    projectMarginSubtitle: "Tržby minus náklady, nejlepší projekty",
    revenueConcentration: "Koncentrace tržeb",
    revenueConcentrationSubtitle: "Podíl fakturovaných tržeb podle projektu",
    perProject: "Rozpis po projektech",
    employeeProfitability: "Ziskovost a vytížení lidí",
    employeeMarginRanking: "Pořadí lidí podle marže",
    employeeMarginSubtitle: "Vytvořené tržby minus náklady",
    utilisation: "Vytížení",
    utilisationSubtitle: "Fakturovatelný podíl vykázaných hodin",
    perEmployee: "Rozpis po lidech",
    noDataPeriod: "Za toto období nejsou žádná data.",
    colProject: "Projekt",
    colHours: "Hodiny",
    colRevenue: "Tržby",
    colCost: "Náklady",
    colMargin: "Marže",
    colMarginPct: "Marže %",
    colEmployee: "Zaměstnanec",
    colBillable: "Fakturovatelné",
    colUtilisation: "Vytížení",
  },
  repActivity: {
    title: "Aktivita",
    subtitle: "Souhrnný proud aktivity napříč všemi projekty",
    all: "Vše",
    types: {
      journal: "Změny",
      comment: "Komentáře",
      timeEntry: "Vykázaný čas",
      syncJob: "Synchronizace",
    },
    groups: {
      today: "Dnes",
      yesterday: "Včera",
      thisWeek: "Tento týden",
      older: "Starší",
    },
    filterUser: "Filtrovat podle uživatele",
    allUsers: "Všichni uživatelé",
    filterProject: "Filtrovat podle projektu",
    allProjects: "Všechny projekty",
    from: "Od",
    to: "Do",
    activityFrom: "Aktivita od",
    activityTo: "Aktivita do",
    system: "Systém",
    view: "Zobrazit",
    none: "Žádná aktivita nenalezena.",
  },
  repMail: {
    title: "Testovací pošta",
    mailbox: "Testovací schránka",
    landsHere: " · vše odeslané na *@{{domain}} skončí tady",
    recipient: "Příjemce…",
    notConfigured: "Testovací schránka není nastavená (TESTER_MAIL_ADDRESS / TESTER_MAIL_PASS).",
    readError: "Schránku se nepodařilo přečíst: {{error}}",
    noSubject: "(bez předmětu)",
    to: "komu: {{addresses}}",
    noMessages: "Žádné zprávy.",
    pageInfo: "Zpráv: {{total}} · strana {{page}} / {{pages}}",
    pick: "Vyberte zprávu.",
    loading: "Načítání…",
    rowFrom: "Od",
    rowTo: "Komu",
    rowReplyTo: "Odpovědět na",
    date: "Datum",
    attachment: "příloha {{n}}",
    text: "Text",
    message: "Zpráva",
    empty: "(prázdné)",
  },
  miscCharts: {
    noData: "Žádná data",
  },
};
